export const GET_TEMPLATES = 'Get_Templates';